import { RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Providers } from "./app/providers";
import { router } from "./app/router";

function ErrorFallback({ error }: { error: Error }) {
  console.error("💥 App Error Boundary caught an error:", error);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-6 text-center">
      <h1 className="mb-4 text-2xl font-bold text-red-600">Algo deu errado ao iniciar o portal</h1>
      <pre className="max-w-full overflow-auto rounded bg-gray-100 p-4 text-sm text-red-500">
        {error.message}
      </pre>
      <button 
        onClick={() => {
          localStorage.clear(); // Limpa estado possivelmente corrompido
          window.location.reload();
        }}
        className="mt-4 rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
      >
        Limpar Cache e Tentar novamente
      </button>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  );
}
